import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Tabs } from 'devextreme-react';
import DeambulazioneAusiliPanel from '../../components/anagraficaTabs/DeambulazioneAusiliPanel';
import DeambulazioneTipiPanel from '../../components/anagraficaTabs/DeambulazioneTipiPanel';
import TenantContext from '../../contexts/tenantContext';
import UtentiPanel from '../../components/utenti/UtentiPanel';
import TipiContattiPanel from '../../components/anagraficaTabs/TipiContattiPanel';
import { UtilitiesApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';

export default function Impostazioni() {
  const { currentTenant } = useContext(TenantContext);
  const [currentTab, setCurrentTab] = useState<string>();

  const tabs = useMemo(() => {
    if (currentTenant?.IsInRole("Proprietario")) {
      return ["Utenti", "Deambulazione Tipi", "Deambulazione Ausili", "Tipi Contatti", "Informazioni"];
    }
    else {
      return ["Deambulazione Tipi", "Deambulazione Ausili", "Informazioni"];
    }
  }, [currentTenant]);

  useEffect(() => {
    if (currentTenant?.IsInRole("Proprietario")) {
      setCurrentTab("Utenti");
    }
    else {
      setCurrentTab("Deambulazione Tipi");
    }
  }, [currentTenant]);

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Impostazioni</h2>
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>

          <Tabs
            dataSource={tabs}
            selectedItem={currentTab}
            onSelectedItemChange={e => setCurrentTab(e)}
            stylingMode='primary'
            width={'100%'}
          />
          {currentTab === "Deambulazione Ausili" &&
            <DeambulazioneAusiliPanel />
          }

          {currentTab === "Deambulazione Tipi" &&
            <DeambulazioneTipiPanel />
          }

          {currentTab === "Informazioni" &&
            <Informazioni />
          }

          {currentTab === "Utenti" &&
            <UtentiPanel />
          }

          {currentTab === "Tipi Contatti" &&
            <TipiContattiPanel />
          }

        </div>
      </div>
    </React.Fragment>
  )
}

function Informazioni() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const appVersion = process.env.REACT_APP_VERSION;
  const [apiVersion, setApiVersion] = useState<String>();

  useEffect(() => {

    (async function () {
      const api = new UtilitiesApi(apiConfiguration);
      setApiVersion(await api.getVersion());
    })();

  }, []);

  return (
    <React.Fragment>
      {process.env.NODE_ENV === 'development' && (
        <p>API URL: {apiUrl}</p>
      )}

      <p>APP VERSION: {appVersion}</p>
      <p>API VERSION: {apiVersion}</p>

    </React.Fragment>
  )
}